import { z } from "zod";
import { BBox, I18nTextRequired, Id, Slug } from "./common.ts";

export const Lake = z
  .object({
    id: Id,
    slug: Slug,
    name: I18nTextRequired,
    /** Mean water surface, metres above sea level (LN02 — same datum as swissBATHY3D). */
    waterLevelM: z.number(),
    /** True when a processed swissBATHY3D COG exists for this lake. */
    hasBathy: z.boolean(),
    /** Grid resolution of the bathymetry in metres (1, 2 or 3); null without bathy. */
    resolutionM: z.number().positive().nullable(),
    bbox: BBox.nullable(),
  })
  .strict();
export type Lake = z.infer<typeof Lake>;

export const LakeList = z.object({ lakes: z.array(Lake) }).strict();
export type LakeList = z.infer<typeof LakeList>;

/** Admin-only: correct the reference water level. */
export const LakeUpdate = z
  .object({ waterLevelM: z.number().min(0).max(5000), name: I18nTextRequired })
  .partial()
  .strict();
export type LakeUpdate = z.infer<typeof LakeUpdate>;
